import { isDefined } from '@aloft/toolkit-shared';

import { COMMENTARY_TEXT } from './consts.ts';

const hasSubtitle = (obj: unknown): obj is { subtitle: string } =>
  typeof obj === 'object' &&
  obj !== null &&
  'subtitle' in obj &&
  typeof (obj as { subtitle: unknown }).subtitle === 'string';

export const getCommentarySectionText = (
  id: keyof typeof COMMENTARY_TEXT,
  options?: { subtitleReplacements?: { [token: string]: string } },
) => {
  const commentaryText = { ...COMMENTARY_TEXT[id] };

  if (
    isDefined(options) &&
    isDefined(options?.subtitleReplacements) &&
    hasSubtitle(commentaryText)
  ) {
    Object.entries(options.subtitleReplacements).forEach(([token, replacement]) => {
      commentaryText.subtitle = commentaryText.subtitle.replace(`{${token}}`, replacement);
    });
  }

  return { ...commentaryText, id };
};
